import { useStyletron } from 'baseui';
import {  HeadingSmall, LabelLarge, ParagraphLarge, ParagraphMedium } from 'baseui/typography';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ParametersViewWrapper } from '../../../features/ParametersView';
import { GetObjectUrl } from '../../../utils/navigationService';
import { StyledLink } from "baseui/link";

export function ListPanel(props: any) {
    const [css,theme] = useStyletron();
    const [url, setUrl] = useState('')

    useEffect(() => {
        setUrl(props.url ? props.url : GetObjectUrl(props.resourceGroupId, props.id));
    }, [props.url, props.resourceGroupId, props.id]);

    const linkStyle = { textDecoration: 'none' }

    return (
        <>
            <Link to={url} className={css(linkStyle)}  >
                <StyledLink animateUnderline>
                    <ParagraphMedium  marginTop={theme.sizing.scale800} >{props.description}</ParagraphMedium>
                </StyledLink>
            </Link>
            <ParametersViewWrapper parentId={props.id} resourceGroupId={props.resourceGroupId}></ParametersViewWrapper>

        </>
    );
}